const NON_BREAKING_HYPHEN = '\u2011';

/** Hyphen between non-space chars → non-breaking hyphen, but keep `{template.keys}` intact. */
const protectCompoundHyphens = (text: string): string =>
    text.replace(/\{[^{}]*\}|(\S)-(?=\S)/g, (match) => {
        if (match.startsWith('{') && match.endsWith('}')) return match;
        return match.replace('-', NON_BREAKING_HYPHEN);
    });

const walkTextNodes = (root: Document | Node, visit: (node: Text) => void) => {
    const doc = root instanceof Document ? root : root.ownerDocument;
    if (!doc) return;
    const walker = doc.createTreeWalker(root instanceof Document ? root.body : root, NodeFilter.SHOW_TEXT);
    const nodes: Text[] = [];
    let current = walker.nextNode();
    while (current) {
        nodes.push(current as Text);
        current = walker.nextNode();
    }
    nodes.forEach(visit);
};

/** Removes text/background colors from Quill HTML so preview matches a print sheet. */
export const stripPreviewHtmlColors = (html: string): string => {
    if (!html) return '';

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    doc.body.querySelectorAll('*').forEach((node) => {
        if (!(node instanceof HTMLElement)) return;

        node.style.removeProperty('color');
        node.style.removeProperty('background');
        node.style.removeProperty('background-color');
        if (!node.getAttribute('style')?.trim()) {
            node.removeAttribute('style');
        }

        Array.from(node.classList).forEach((className) => {
            if (className.startsWith('ql-color-') || className.startsWith('ql-bg-')) {
                node.classList.remove(className);
            }
        });
        if (!node.className.trim()) {
            node.removeAttribute('class');
        }
    });

    walkTextNodes(doc, (node) => {
        const next = protectCompoundHyphens(node.nodeValue || '');
        if (next !== node.nodeValue) node.nodeValue = next;
    });

    return doc.body.innerHTML;
};
